import React from 'react';
import PropTypes from 'prop-types';
import { RemoteStoreState } from 'Webapp/enums';
import sentry from 'Utils/sentry';
import logger from 'Utils/logger';
import getWindow from 'Utils/get-window';
import Config from 'Config';

class LoadFullProfile extends React.Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
    this.triedToLoadPublisherInfo = false;
    this.maxRetries = 10;
    this.state = {
      retries: 0,
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate() {
    this.load();
  }

  load() {
    const {
      profileLoaded,
      profileIsLoading,
      fetchFullProfile,
      fetchPublisherInfo,
      publisherRemoteStoreState,
      uid,
    } = this.props;
    if (this.state.retries >= this.maxRetries) {
      // something is really wrong.  Something else should probably
      // have already redirected the user away, but for some reason
      // has not, or the client isn't following redirects or
      // something?  In any case, no more requests.
      getWindow().location = Config.LOGOUT_URL;
      return;
    }
    if (!profileLoaded && !profileIsLoading) {
      fetchFullProfile(uid);
      this.setState({ retries: this.state.retries + 1 });
    }
    // We keep fetchPublisherInfo out of fetchFullProfile because the
    // publisher endpoint is unreliable, and most users are not
    // publishers.  fetchFullProfile can finish much faster (and we
    // can start rendering most of what we need this for) without
    // publisher info
    if (publisherRemoteStoreState === RemoteStoreState.INITIAL) {
      if (this.triedToLoadPublisherInfo) {
        const at = new Date().getTime();
        sentry.captureException(new Error('PUBLISHER INFO LOADED TOO MUCH'), {
          uid,
          publisherRemoteStoreState,
          at,
        });
        logger.warn(
          `PUBLISHER INFO LOADED TOO MUCH: uid: ${uid}, publisherRemoteStoreState: ${publisherRemoteStoreState}, at: ${at}`,
        );
      }
      fetchPublisherInfo(uid);
      this.triedToLoadPublisherInfo = true;
    }
  }

  render() {
    // no-op
    return null;
  }
}

LoadFullProfile.propTypes = {
  uid: PropTypes.number.isRequired,
  profileIsLoading: PropTypes.bool.isRequired,
  profileLoaded: PropTypes.bool.isRequired,
  fetchFullProfile: PropTypes.func.isRequired,
  publisherRemoteStoreState: PropTypes.oneOf(Object.keys(RemoteStoreState)),
  fetchPublisherInfo: PropTypes.func.isRequired,
};

export default LoadFullProfile;
